import router from "@/router";
import store from "@/store";
export default {
  getMenu() {
    let navData = [
      {
        id: "1",
        name: "中心概况",
        router: "centerOverviewPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "centerOverviewPublish",
        pagePath: "managePage/centerOverviewPublish",
        type: "page",
        openType: "current",
      },
      {
        id: "2",
        name: "新闻动态",
        router: "newsDynamicPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "newsDynamicPublish",
        pagePath: "managePage/newsDynamicPublish",
        type: "page",
        openType: "current",
      },
      {
        id: "3",
        name: "献血服务",
        router: "bloodServicePublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "bloodServicePublish",
        pagePath: "managePage/bloodServicePublish",
        type: "page",
        openType: "current",
      },
      {
        id: "4",
        name: "献血者家园",
        router: "donorHomePublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "donorHomePublish",
        pagePath: "managePage/donorHomePublish",
        type: "page",
        openType: "current",
      },
      {
        id: "5",
        name: "信息公开",
        router: "infoDisclosure", // 首字母小写（Info简化为info）
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: null,
        pagePath: null,
        type: "menu",
        openType: null,
        children: [
          {
            id: "5-1",
            name: "通知公告",
            router: "noticePublish", // 首字母小写
            hidden: false,
            routerPath: "infoDisclosure/noticePublish",
            pagePath: "managePage/noticePublish",
            type: "page",
            openType: "current",
          },
          {
            id: "5-2",
            name: "血液供应",
            router: "bloodSupplyPublish", // 首字母小写
            hidden: true,
            routerPath: "infoDisclosure/bloodSupplyPublish",
            pagePath: "managePage/bloodSupplyPublish",
            type: "page",
            openType: "current",
          },
          {
            id: "5-3",
            name: "法律法规",
            router: "policyLawPublish", // 首字母小写
            hidden: false,
            routerPath: "infoDisclosure/policyLawPublish",
            pagePath: "managePage/policyLawPublish",
            type: "page",
            openType: "current",
          },
          {
            id: "5-4",
            name: "媒体中心",
            router: "mediaCenterPublish", // 首字母小写
            hidden: true,
            routerPath: "infoDisclosure/mediaCenterPublish",
            pagePath: "managePage/mediaCenterPublish",
            type: "page",
            openType: "current",
          },
        ],
      },
      {
        id: "6",
        name: "党建文明",
        router: "partyConstructionPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "partyConstructionPublish",
        pagePath: "managePage/partyConstructionPublish",
        type: "page",
        openType: "current",
      },
      {
        id: "7",
        name: "联系我们",
        router: "contactUsPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "contactUsPublish",
        pagePath: "managePage/contactUsPublish",
        type: "page",
        openType: "current",
      },
      {
        id: "8",
        name: "内容管理",
        router: "NewsPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: true,
        routerPath: "NewsPublish",
        pagePath: "NewsPublish",
        type: "page",
        openType: "current",
      },
      {
        id: "9",
        name: "友情链接",
        router: "friendlyPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "friendlyPublish",
        pagePath: "managePage/friendlyPublish",
        type: "page",
        openType: "current",
      },
      {
        id: "10",
        name: "库存情况",
        router: "inventoryPublish", // 首字母小写
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: "inventoryPublish",
        pagePath: "managePage/inventoryPublish",
        type: "page",
        openType: "current",
      },
    ];
    store.commit("changeNavData", navData);
  },
  addRoute(arr) {
    for (let item of arr) {
      if (item.type == "page") {
        router.addRoute("Main", {
          path: item.routerPath,
          name: item.router,
          component: () => import("@/views/" + item.pagePath),
          meta: {
            title: item.name,
          },
        });
      }
      if (item.children && item.children.length > 0) {
        this.addRoute(item.children);
      }
    }
  },
  findNavItem(router, arr) {
    console.log(router, arr);
    for (let item of arr) {
      if (item.router == router) {
        return item;
      } else {
        if (item.children && item.children.length > 0) {
          let result = this.findNavItem(router, item.children);
          if (result) return result;
        }
      }
    }
  },
  getDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return year + "-" + month + "-" + day;
  },
};
